import { render, staticRenderFns } from "./G4PresentadoVsAprobadoXArea.vue?vue&type=template&id=e93f6766&"
import script from "./G4PresentadoVsAprobadoXArea.vue?vue&type=script&lang=js&"
export * from "./G4PresentadoVsAprobadoXArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
